export default __webpack_public_path__ + "static/media/search.51e0cfb6.svg";